import * as HLF from "html-living-framework";
import {Keyboard} from "../GameObjects/Keyboard";
import {VoiceOverManager} from "../Managers/VoiceOverManager";
import {StateName} from "../Data/StateName";
import {updateStateAssets} from "../Data/Assets";
import {GameManager} from "../Managers/GameManager";
import {playVO, voOptionsIdle} from "../Data/VoiceOver";

export class AbstractGameState extends HLF.State {

    public readonly gameManager = GameManager.instance;
    private _activityCompleteIdleTimeout?: number;

    public init(pSize: PIXI.Point, pData?: any) {
        super.init(pSize);

        Keyboard.clear();
        Keyboard.enabled = true;
    }

    public lockScreen() {
        this.interactiveChildren = false;
        Keyboard.enabled = false;
    }

    public unlockScreen() {
        this.interactiveChildren = true;
        Keyboard.enabled = true;
    }

    public gotoState<T>(name: StateName, data?: T) {
        updateStateAssets(name, data as any);
        VoiceOverManager.instance.stopVO();
        const steps = [
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.ShowLoadScreen,
            HLF.TransitionStep.LoadAssets,
            HLF.TransitionStep.HideLoadScreen,
            HLF.TransitionStep.AttachNewInFront,
            HLF.TransitionStep.AnimNewIn,
        ];
        PubSub.publishSync(
            HLF.STATE_LOAD_STATE, data ?
                new HLF.StateToken({id: name, data}, StateName.Load, ...steps) :
                new HLF.StateToken(name, StateName.Load, ...steps),
        );
    }

    startActivityCompleteIdle() {
        const time = (this._activityCompleteIdleTimeout === undefined ? 5 : 23) * 1000;
        window.clearTimeout(this._activityCompleteIdleTimeout);
        this._activityCompleteIdleTimeout = window.setTimeout(() => {
            playVO(this.getActivityCompleteIdleVO(), voOptionsIdle);
            this.startActivityCompleteIdle();
        }, time);
    }

    stopActivityCompleteIdle() {
        window.clearTimeout(this._activityCompleteIdleTimeout);
    }

    getActivityCompleteIdleVO() {
        return "LetsGoLuna_007-b";
    }

    destroy(pOptions?: Parameters<typeof PIXI.Container.prototype.destroy>[0]) {
        this.stopActivityCompleteIdle();
        super.destroy(pOptions);
    }
}
